module.exports = __webpack_public_path__ + "img/GroupScheduleExams.52c8eef6.svg";